import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeInFromBottom } from '../animations';
import { viewport } from '../getViewport';

export const storySplitscreen = () => {
  const storySplitscreen = $('.story-splitscreen');

  if (storySplitscreen) {
    const images = $$('.story-splitscreen__media-item', storySplitscreen);

    const imagesTop = images.slice(0, 2);
    const imagesBottom = images.slice(2, 4);

    const timeline = gsap.timeline({ repeat: -1 });

    gsap.set(imagesTop[1], { opacity: 0 });
    gsap.set(imagesBottom[1], { opacity: 0 });

    timeline.to(imagesTop[0], { opacity: 0, duration: 5 }, '+5');
    timeline.to(imagesTop[1], { opacity: 1, duration: 5 }, '<');

    timeline.to(imagesBottom[0], { opacity: 0, duration: 5 }, '<+5');
    timeline.to(imagesBottom[1], { opacity: 1, duration: 5 }, '<');

    timeline.to(imagesTop[1], { opacity: 0, duration: 5 }, '<+5');
    timeline.to(imagesTop[0], { opacity: 1, duration: 5 }, '<');

    timeline.to(imagesBottom[1], { opacity: 0, duration: 5 }, '<+5');
    timeline.to(imagesBottom[0], { opacity: 1, duration: 5 }, '<');

    ScrollTrigger.create({
      animation: timeline,
      trigger: storySplitscreen,
      start: () => 'top bottom',
      end: () => 'bottom top',
      toggleActions: 'play pause resume reset',
    });

    fadeInFromBottom(
      $$('.story-splitscreen__headline', storySplitscreen),
      viewport.isReduced
        ? 0
        : viewport.isDesktop
        ? 150
        : viewport.isTablet
        ? 50
        : viewport.isMobile
        ? 50
        : 0
    );
    fadeInFromBottom($$('.story-splitscreen__content', storySplitscreen));
  }
};
